module.exports = __webpack_public_path__ + "img/uros.24e14152.jpg";